import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

export const LicenseColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  optionData,
) => {
  function shortenListWithDots(input) {
    const parts = input.split(",").map((s) => s.trim());
    if (parts.length <= 2) return input; // No need to shorten if 2 or fewer items
    return `${parts.slice(0, 2).join(", ")}, ...`;
  }
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  return [
    // {
    //   title: "No",
    //   dataIndex: "LicenseNo",
    //   key: "LicenseNo",
    //   sorter: (a, b) => a?.LicenseNo - b?.LicenseNo,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="LicenseNo"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "LicenseNo",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Name",
      dataIndex: "LicenseName",
      key: "LicenseName",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="LicenseName"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "LicenseName",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Description",
      dataIndex: "LicenseDesc",
      key: "LicenseDesc",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="LicenseDesc"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "LicenseDesc",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "License Type",
    //   dataIndex: "LicenseType",
    //   key: "LicenseType",
    //   sorter: (a, b) => a?.LicenseType?.length - b?.LicenseType?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="LicenseType"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "LicenseType",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Product",
    //   dataIndex: "Product",
    //   key: "Product",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Product"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Product",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Old Model",
    //   dataIndex: "OldModel",
    //   key: "OldModel",
    //   sorter: (a, b) => a?.OldModel?.length - b?.OldModel?.length,
    //   render: (text, record) => {
    //     return record.LicenseType !== "Upgrade License" ? "N/A" : text;
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OldModel"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OldModel",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Site Type",
    //   dataIndex: "SiteType",
    //   key: "SiteType",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="SiteType"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "SiteType",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "Model",
      dataIndex: "Model",
      key: "Model",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Model"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Model",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Door",
      dataIndex: "Type",
      key: "Type",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Type"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Type",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    // {
    //   title: "License Options",
    //   dataIndex: "Options",
    //   key: "Options",
    //   render: (text) => {
    //     return text?.length > 0 ? shortenListWithDots(text) : "";
    //   },
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Options"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Options",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "License Devices",
    //   dataIndex: "Devices",
    //   key: "Devices",
    //   render: (text) => {
    //     return text?.length > 0 ? shortenListWithDots(text) : "";
    //   },
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Devices"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Devices",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Monthly",
    //   dataIndex: "Monthly",
    //   key: "Monthly",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="Monthly"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "Monthly",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "One Time",
    //   dataIndex: "OneTime",
    //   key: "OneTime",
    //   sorter: (a, b) => () => {},
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={modParams.order}
    //       columnKey="OneTime"
    //       sortBy={modParams.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...modParams,
    //         sort_by: "OneTime",
    //         order: modParams.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },

    // {
    //   title: "Old Type",
    //   dataIndex: "OldType",
    //   key: "OldType",
    //   sorter: (a, b) => a?.OldType?.length - b?.OldType?.length,
    //   render: (text, record) => {
    //     return record.LicenseType !== "Upgrade License" ? "N/A" : text;
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OldType"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OldType",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Type",
    //   dataIndex: "Type",
    //   key: "Type",
    //   sorter: (a, b) => a?.Type?.length - b?.Type?.length,
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="Type"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "Type",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "OEM",
    //   dataIndex: "OemName",
    //   key: "OemName",
    //   sorter: (a, b) => a?.OemName?.length - b?.OemName?.length,
    //   render: (text, record) => {
    //     return record.LicenseType === "Upgrade License" ? "N/A" : text;
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="OemName"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "OemName",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    // {
    //   title: "Price",
    //   dataIndex: "Price",
    //   key: "Price",
    //   sorter: (a, b) => a?.Price?.length - b?.Price?.length,
    //   render: (text) => {
    //     return <p>{text == 0 ? "N/A" : text}</p>;
    //   },
    //   sortIcon: () => (
    //     <SortIcon
    //       sortOrder={params.order}
    //       columnKey="Price"
    //       sortBy={params.sort_by}
    //     />
    //   ),
    //   onHeaderCell: () => ({
    //     onClick: () =>
    //       setParams((prev) => ({
    //         ...prev,
    //         sort_by: "Price",
    //         order: prev.order === "desc" ? "asc" : "desc",
    //       })),
    //   }),
    // },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      render: (text, record, rowIndex) =>
        hoveredRow === rowIndex ? (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Edit">
                <div className="hover:bg-gray-400 px-[5px] py-1 rounded-[4px] mr-1 ">
                  <Link
                    to={`/license/edit/${record?.LicenseNo}`}
                    onClick={(e) => e.stopPropagation()}
                    className=" hover:text-[#636262ee]"
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="!text-[#50565e]"
                    />
                  </Link>
                </div>
              </Tooltip>
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.LicenseNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-1 rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        ) : null,
    },
  ];
};
